import { BgColor, TextColor } from './types';

export const BgColors = [
  'zapier',
  'night',
  'moss',
  'neutral800',
  'neutral100',
  'earth',
];

export const BgColorMap: { [key: string]: BgColor } = {
  lava60: 'zapier',
  ocean40: 'night',
  sun60: 'moss',
  white: 'neutral100',
};

export const TextColorMap: { [key: string]: TextColor } = {
  zapier: 'cream',
  neutral100: 'neutral800',
  night: 'neutral100',
  moss: 'neutral100',
  neutral800: 'neutral100',
  earth: 'neutral100',
};
